import { App } from 'vue';
// import vueSignature from 'vue-signature';
import { IgentifyPlayer } from 'igentify-player';
import { store } from '@/main';
import { videoModule } from './store';

export const VideoPlugin = {
  install: (app: App) => {
    app.component('IgentifyPlayer', IgentifyPlayer);
    // app.component('VueSignature', vueSignature);
    // @ts-ignore
    store.registerModule('video', videoModule);
  },

  // protected pluginInstalled(vm: VueConstructor, instance: Vue) {
  //   super.pluginInstalled(vm, instance);
  //
  //   vm.use(vueSignature);
  //   vm.use(IgentifyPlayer, playerOptions);
  // }
};
